[].slice.call(document.querySelectorAll('[data-bs-toggle="popover"], [popover]')).map(element => new bootstrap.Popover(element))
